import { APIURLLEGALES, APIURLREINGENIERIALEGALES } from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter {
  async fetchObservaciones(fechaDesde, fechaHasta, idJuicio, nroExpediente, caratula, observacion, idDelegacion, nroSiniestro, idProfesional, idEstadoObservacion, idTipoMotivoRechazo) {
    const url = APIURLLEGALES + `/observaciones/Listar?fechaDesde=${fechaDesde || ''}&fechaHasta=${fechaHasta || ''}&idJuicio=${idJuicio || ''}&nroExpediente=${nroExpediente || ''}&caratula=${caratula || ''}&observacion=${observacion || ''}&idDelegacion=${idDelegacion || ''}&nroSiniestro=${nroSiniestro || ''}&idProfesional=${idProfesional || ''}&idEstadoObservacion=${idEstadoObservacion || ''}&idTipoMotivoRechazo=${idTipoMotivoRechazo || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchObservacionPorId(idObservacion) {
    const url = APIURLLEGALES + `/observaciones/Obtener?idObservacion=${idObservacion || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchAltaObservacion(body) {
    const url = APIURLLEGALES + `/observaciones/enviar`
    const response = apiClient.postData(url, body)
    const data = await response
    return data;
  }

  async fetchMotivosRechazo() {
    const url = APIURLLEGALES + "/observaciones/MotivosRechazo"
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchEstadosObservacion() {
    const url = APIURLLEGALES + "/observaciones/Estados"
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchObservacionesByIdReingenieria(nroJuicio, cuit) {
    const url = APIURLREINGENIERIALEGALES + `/GetObservaciones?nroJuicio=${nroJuicio || ''}&letradoCiaCUILCUIT=${cuit || ''}`

    const response = apiClient.get(url,{useReing: true});
    const data = await response

    return data;
  }

}

export default ApiServiceAdapter